export const getAppVersion = (): string => {
    const pjson = require('../../../../../../../../package.json');
    return pjson.version;
}
